"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putApiCall = exports.postApiCall = exports.getApiCall = exports.deleteApiCall = exports.apiCall = void 0;
var _genericFetch = require("../utils/genericFetch");
var _baseAPI = require("./baseAPI");
const apiCall = async ({
  requestType,
  ...props
}) => {
  // // // console.log('===apiCall start', Date.now());
  let response = {};
  switch (requestType) {
    case 'GET':
      response = await getApiCall({
        requestType,
        ...props
      });
      // // // console.log('===getApiCall end', Date.now());
      // // // console.log('===apiCall end', Date.now());
      break;
    case 'POST':
      response = await postApiCall({
        requestType,
        ...props
      });
      break;
    case 'DELETE':
      response = await deleteApiCall({
        requestType,
        ...props
      });
      break;
    case 'PUT':
      response = await putApiCall({
        requestType,
        ...props
      });
      break;
    default:
      response = await getApiCall({
        requestType,
        ...props
      });
  }
  return response;
};
exports.apiCall = apiCall;
const manageAPIResponse = async ({
  apiEndPoint,
  responseManupulatedType = 1,
  responseData,
  requestType,
  ...props
}) => {
  let {
    currentRetry,
    retry
  } = props;
  if (responseData.status === 200 || responseData.status === 201) {
    let response;
    if (responseManupulatedType === 1) {
      response = {
        ...responseData.data.data,
        status: responseData.status || '',
        // API Status
        responseStatus: responseData.data.data.status // Response status like appointmentStatus etc
      };
    }
    return response;
  } else if (retry) {
    currentRetry = (currentRetry || 1) + 1;
    if (currentRetry <= retry) {
      props.currentRetry = currentRetry;
      props.retry = retry;
      return apiCall({
        apiEndPoint,
        requestType,
        ...props
      });
    } else {
      return responseData;
    }
  } else {
    return responseData;
  }
};
const getApiCall = ({
  apiEndPoint,
  requestType,
  ...props
}) => {
  // // // console.log('===getApiCall start', Date.now());
  return (0, _baseAPI.get)({
    path: apiEndPoint,
    ...props
  }).then(responseData => {
    // // // console.log('===get end', Date.now());
    return manageAPIResponse({
      apiEndPoint,
      responseData,
      requestType,
      ...props
    });
  }).catch(error => {
    throw (0, _genericFetch.getGenericErrorObject)({
      error,
      apiEndPoint,
      requestType
    });
  });
};
exports.getApiCall = getApiCall;
const postApiCall = async ({
  apiEndPoint,
  apiPostData,
  requestType,
  ...props
}) => {
  return (0, _baseAPI.post)({
    path: apiEndPoint,
    body: apiPostData,
    ...props
  }).then(responseData => {
    return manageAPIResponse({
      apiEndPoint,
      responseData,
      requestType,
      ...props
    });
  }).catch(error => {
    // Need to work on this
    throw (0, _genericFetch.getGenericErrorObject)({
      error,
      apiEndPoint,
      requestType
    });
  });
};
exports.postApiCall = postApiCall;
const deleteApiCall = ({
  apiEndPoint,
  apiPostData,
  requestType,
  ...props
}) => {
  return (0, _baseAPI.del)({
    path: apiEndPoint,
    body: apiPostData || null,
    ...props
  }).then(responseData => {
    return manageAPIResponse({
      apiEndPoint,
      responseData,
      requestType,
      ...props
    });
  }).catch(error => {
    throw (0, _genericFetch.getGenericErrorObject)({
      error,
      apiEndPoint,
      requestType
    });
  });
};
exports.deleteApiCall = deleteApiCall;
const putApiCall = ({
  apiEndPoint,
  apiPostData,
  requestType,
  ...props
}) => {
  return (0, _baseAPI.put)({
    path: apiEndPoint,
    body: apiPostData,
    ...props
  }).then(responseData => {
    return manageAPIResponse({
      apiEndPoint,
      responseData,
      requestType,
      ...props
    });
  }).catch(error => {
    throw (0, _genericFetch.getGenericErrorObject)({
      error,
      apiEndPoint,
      requestType
    });
  });
};
exports.putApiCall = putApiCall;